import * as React from 'react';
import { StyledHTMLElement } from 'styletron-react';
import { styled } from 'styletron-react';

export const ReferenceStyle: React.CSSProperties = {
    fontFamily: 'Segoe UI',
    fontSize: '0.8rem',
    fontWeight: 400,
    color: 'rgba(0,0,0,0.6)',
    textTransform: 'uppercase'
};

export const Reference = styled('span', ReferenceStyle);



// WEBPACK FOOTER //
// ./primitives/Reference.tsx